import React from 'react'
import styled from 'styled-components'

export interface IconTileProps {
  /** Background color of the square tile. */
  color: string
  /** Icon rendered inside the tile. */
  icon: React.ReactNode
  /** Foreground color for the icon. Defaults to `currentColor`. */
  iconColor?: string
  className?: string
}

export const IconTile: React.FC<IconTileProps> = ({ color, icon, iconColor, className }) => (
  <Tile className={className} $background={color} $iconColor={iconColor} aria-hidden="true">
    {icon}
  </Tile>
)

const Tile = styled.div<{
  $background: string
  $iconColor?: string
}>`
  width: ${({ theme }) => theme.iconTile.size}rem;
  height: ${({ theme }) => theme.iconTile.size}rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: ${({ $background }) => $background};
  color: ${({ $iconColor }) => $iconColor || 'currentColor'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: ${({ theme }) => theme.iconSize.xs}rem;

  svg {
    width: ${({ theme }) => theme.iconSize.xs}rem;
    height: ${({ theme }) => theme.iconSize.xs}rem;
  }
`
